module.exports = {
  formatMoney: require("./format_money.js"),
  calculateMortgage: require("./calculate_mortgage.js"),
  amortization: require("./amortization.js")
};
